import { FontSizes, FontWeights } from '@fluentui/react';
export var FontFamily = '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI",' +
    ' -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif';
export var dataGridColumnStyle = function (theme) {
    return {
        fontProperties: {
            fontFamily: FontFamily,
            lineHeight: '20px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        },
        textColor: { color: theme.semanticColors.bodyText },
        secondaryLinkColor: { color: theme.semanticColors.bodyText + " !important" },
        linkColor: { color: theme.palette.themePrimary },
        overdueColor: { color: theme.semanticColors.alertDoNotDisturb },
        alignLeft: { textAlign: 'left' },
        alignRight: { textAlign: 'right' },
        leftAlignedCellContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: '100%'
        },
        rightAlignedCellContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: '100%'
        },
        actionsContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start'
        },
        actionsContainerInvert: {
            justifyContent: 'flex-end'
        },
        icon: {
            height: '14px',
            color: theme.semanticColors.bodyText,
            padding: '0px 10px',
            minWidth: '15px',
            width: '15px',
            backgroundColor: 'transparent'
        },
        dot: {
            height: '8px',
            width: '8px',
            borderRadius: '50%',
            display: 'inline-block',
            marginRight: '4px'
        },
        fontIcon: {
            color: theme.semanticColors.bodyText,
            marginRight: '4px',
            lineHeight: '22px',
            fontSize: FontSizes.size16,
            fontWeight: FontWeights.regular
        }
    };
};
export var PersonaStyles = function (theme) {
    return {
        primaryText: {
            color: theme.semanticColors.bodyText,
            textOverflow: 'ellipsis',
            textAlign: 'left',
            fontFamily: FontFamily,
            lineHeight: '20px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        }
    };
};
export var IconButtonBaseStyles = function (theme) {
    return {
        color: theme.palette.neutralPrimary,
        backgroundColor: 'transparent',
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.regular
    };
};
export var IconButtonStyles = function (theme) {
    var baseStyles = IconButtonBaseStyles(theme);
    return {
        root: baseStyles,
        rootHovered: baseStyles,
        rootPressed: baseStyles,
        icon: baseStyles,
        iconHovered: baseStyles,
        iconPressed: baseStyles
    };
};
//# sourceMappingURL=DataGridColumn.styles.js.map